import { SignalRHub } from "../types/SignalRHub";
import { batchDownloadClientMethodNames } from "./sections/BatchDownloadSection";
import { dossierClientMethodNames } from "./sections/DossierSection";
import { liveStreamingClientMethodNames } from "./sections/LiveStreamingSection";

export enum MessageHubMethodNames {
    SubscribeToGroupUpdates = "SubscribeToGroupUpdates",
    UnsubscribeFromGroupUpdates = "UnsubscribeFromGroupUpdates",
}

export class MessageHub implements SignalRHub {
    hubName = "Message";
    hubMethodNames = [
        MessageHubMethodNames.SubscribeToGroupUpdates,
        MessageHubMethodNames.UnsubscribeFromGroupUpdates,
    ];
    clientMethodNames = [
        ...liveStreamingClientMethodNames,
        ...batchDownloadClientMethodNames,
        ...dossierClientMethodNames,
    ];
}
